import { render, staticRenderFns } from "./ApprovalCard.vue?vue&type=template&id=f38dbe94&scoped=true&"
import script from "./ApprovalCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalCard.vue?vue&type=style&index=0&id=f38dbe94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38dbe94",
  null
  
)

export default component.exports